import { cpf as cpfValidator } from 'cpf-cnpj-validator'

type ValidateCpfProps = {
  cpf: string
}

export function validateCpf({ cpf }: ValidateCpfProps): boolean {
  return cpfValidator.isValid(cpf)
}
